module.exports = __webpack_public_path__ + "static/media/CSPORT LINEAR ARM AFU1-2.51dacd55.png";